import { useQuery } from "@tanstack/react-query";
import { getLanguages } from "../../../api/endpoints/LearningPathEndpoints";

export default function useGetLanguages() {
  return useQuery({
    queryKey: ["languages"],
    queryFn: getLanguages,
  });
}
